<template>
  <div class="container-fluid py-3 py-md-4 px-3 px-md-4">
    <div class="row align-items-stretch g-4">
      <!-- ستون اول -->
      <div class="col-12 col-lg-6 d-flex">
        <div class="info-card w-100 h-100">
          <h2 class="title mb-4">{{ currentLang.title }}</h2>

          <ul class="feature-list mb-4"  :dir="lang === 'fa' ? 'rtl' : 'ltr'">
            <li  v-for="(feature, index) in currentLang.features" :key="index" >
              {{ feature }}
            </li>
          </ul>

          <p class="desc mb-0">
            {{ currentLang.description }}
          </p>
        </div>
      </div>

      <!-- ستون دوم -->
     <div class="col-12 col-lg-6 d-flex">
  <!-- با افزودن overflow-hidden خیالتان کاملاً راحت می‌شود -->
  <div class="video-wrapper w-100 overflow-hidden">
    <div id="11948722021" class="aparat-box"></div>
  </div>
</div>

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted,computed } from "vue";
import { showLoading, hideLoading } from "@/stores/loading";

import { lang} from "@/plugins/lang";
import enAuth from "@/locales/en/slider";
import faAuth from "@/locales/fa/slider";

const translations = {
  en: enAuth,
  fa: faAuth,
};
const currentLang = computed(() => translations[lang.value]);

const loading = ref(true);

const fetchData = async () => {
  try {
    loading.value = true;
    showLoading();

    const script = document.createElement("script");
    script.type = "text/JavaScript";
    script.src =
      "https://www.aparat.com/embed/pohq5h7?data[rnddiv]=11948722021&data[responsive]=yes";
    document.getElementById("11948722021")?.appendChild(script);
  } catch (error) {
    loading.value = false;
  } finally {
    loading.value = false;
    hideLoading();
  }
};

onMounted(fetchData);
</script>

<style scoped>
.info-card {
  background: linear-gradient(135deg, #6cceff 0%, #ffffff 55%, #eaf8ff 100%);
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.title {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.8;
  color: #18325b;
}


.feature-list {
  list-style: none;
  margin-bottom: 0;
}

/* فارسی */
.feature-list[dir="rtl"] {
  direction: rtl;
  text-align: right;
  padding-right: 0;
  padding-left: 0;
}

.feature-list[dir="rtl"] li {
  padding-right: 22px;
  padding-left: 0;
}

.feature-list[dir="rtl"] li::before {
  right: 0;
  left: auto;
}

/* انگلیسی */
.feature-list[dir="ltr"] {
  direction: ltr;
  text-align: left;
  padding-right: 0;
  padding-left: 0;
}

.feature-list[dir="ltr"] li {
  padding-left: 22px;
  padding-right: 0;
}

.feature-list[dir="ltr"] li::before {
  left: 0;
  right: auto;
}

/* تنظیمات مشترک هر آیتم */
.feature-list li {
  position: relative;
  margin-bottom: 12px;
  font-size: 1rem;
  line-height: 1.9;
  color: #374151;
}

/* دایره رنگی */
.feature-list li::before {
  content: "";
  position: absolute;
  top: 12px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #00cdc4;
}


.desc {
  font-size: 1rem;
  line-height: 2;
  color: #4b5563;
}

.video-wrapper {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  background: #000;
  min-height: 100%;
}

.aparat-box {
  width: 100%;
  height: 100%;
  min-height: 100%;
}

@media (max-width: 991.98px) {
  .info-card {
    padding: 20px;
  }

  .title {
    font-size: 1.35rem;
  }

  .video-wrapper {
    min-height: 320px;
  }
}

@media (max-width: 575.98px) {
  .info-card {
    padding: 18px;
    border-radius: 16px;
  }

  .video-wrapper {
    border-radius: 16px;
    min-height: 260px;
  }

  .title {
    font-size: 1.2rem;
  }

  .feature-list li,
  .desc {
    font-size: 0.95rem;
  }
}
</style>
